/**
 * Single source of truth for in-product support entry points (F049; F161).
 *
 * F161 dropped the `mailto:` fallback entirely — `SupportPanel` (right-side
 * Sheet) is the only "Falar com o suporte" surface now. This module only
 * carries the docs link.
 */

// TODO(L003): swap to https://babiluapp.com/ajuda/ once the LP help center
// publishes (still in inbox-bot-lp's workflow/backlog/ as of F161).
/** Public docs / help site. Opens in a new tab. */
export const SUPPORT_DOCS_URL = 'https://babiluapp.com';
